import { combineReducers } from 'redux';
import params from './params';
import data from './data';

const rootReducer = combineReducers({
  params,
  data,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js